import { CommandItem } from "@/components/ui/command"
import { joinStrings } from "@/lib/joinString"
import { type MedicationSearchResultsType } from "@/modules/patients/detail/medication/de/search-results"
import { RecommendedMedicationItem } from "@/modules/patients/detail/recommended-medications/components/recommended-medication-item"
import { type useDeMedicationSearchQuery$data } from "@/modules/patients/services/de/__generated__/useDeMedicationSearchQuery.graphql"

export type DeMedicationResult = NonNullable<useDeMedicationSearchQuery$data["de_preparations"]["result"]>
export type DeSubstanceResult = NonNullable<useDeMedicationSearchQuery$data["de_substances"]["result"]>

type DeMedicationSearchResultsProps = {
  searchText: string
  preparations?: DeMedicationResult
  substances?: DeSubstanceResult
  handleSelectSearchItem: (selectedItem: MedicationSearchResultsType) => void
}
export const DeRecommendedMedicationsSearchResult = (props: DeMedicationSearchResultsProps) => {
  const { searchText, preparations, substances, handleSelectSearchItem } = props

  return (
    <div className="px-2 pt-2.5">
      {substances?.map((substance) => (
        <CommandItem
          key={substance.substanceId}
          className="cursor-pointer rounded-md"
          onSelect={() => handleSelectSearchItem({ substance })}
          value={substance.substanceId.toString()}>
          <RecommendedMedicationItem title={substance.nameHtml} text={substance.nameHtml} searchText={searchText} />
        </CommandItem>
      ))}

      {preparations?.map((preparation) => {
        const formattedName = joinStrings([preparation.name, ...preparation.composition])
        const pharmaceuticalName = preparation.pharmaceuticalForm?.name?.trim()

        return (
          <CommandItem
            key={preparation.productId}
            className="cursor-pointer rounded-md"
            value={preparation.productId.toString()}
            onSelect={() => handleSelectSearchItem({ preparation })}>
            <RecommendedMedicationItem
              title={formattedName}
              text={formattedName}
              searchText={searchText}
              extra={
                <div className="grid">
                  {pharmaceuticalName && <span className="text-on-surface-subdued text-xs">{pharmaceuticalName}</span>}
                  {preparation.pharmaceuticalCentralNumberList?.map((pharma) => {
                    const formattedPreparationText = `${pharma.unit} (${pharma.quantity}) ${pharma.price}`
                    return (
                      <span key={pharma.pharmaceuticalCentralNumber} className="text-on-surface-subdued text-xs">
                        {formattedPreparationText}
                      </span>
                    )
                  })}
                </div>
              }
            />
          </CommandItem>
        )
      })}
    </div>
  )
}
